<template>
  <div class="register-box">
    <!-- <div class="quick-box" @click="go('quick')">
      <h3>快捷注册</h3>
      <p>
        快捷注册可成为本会网员注册成功后，可通过
        登录帐号报名参加本会组织的会议活动及会议
        签到等。
      </p>
    </div> -->
    <div class="member-box">
      <h3>会员注册</h3>
      <p>
        会员注册需在线填写会员信息，缴纳会费后
        正式成为本会会员，会员可享受本会提供的
        各种增值服务，详见入会须知。
      </p>
      <div class="btn-box">
        <span @click="go('personRegister')">个人会员</span>
        <span @click="go('groupRegister')">单位会员</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    go(type) {
      this.$router.push({ name: type });
    }
  }
};
</script>

<style lang="less" scoped>
.register-box {
  padding: 28px 0;
}
h3 {
  margin: 0;
  font-weight: normal;
  font-size: 18px;
  text-align: center;
}
p {
  margin: 16px 0 0;
  font-size: 14px;
  line-height: 24px;
}
.quick-box {
  padding: 26px;
  color: #fff;
  background: #66666c;
  &:active {
    background: #4b4b4e;
  }
}
.member-box {
  margin-top: 18px;
  padding-top: 26px;
  padding-bottom: 0;
  color: #fff;
  background: #228ccd;
  p {
    padding: 16px 26px;
    margin-top: 0;
  }
}
.btn-box {
  display: flex;
  border-top: 1px solid #31a0e4;
  span {
    width: 50%;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
    &:active {
      background: #107abb;
    }
  }
  span {
    border-left: 1px solid #31a0e4;
  }
}
</style>
